import React from 'react';
import { Link } from 'react-router';
import ItemSuggestions from '../../components/items/ItemSuggestions';
import {
  LISTING_TYPE_OPTIONS,
  SELLER_LISTING_DESTINATIONS,
} from '../../constants/listingTypeOptions';
import styled from 'styled-components';

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #a8e6cf 0%, #88d8a3 100%);
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`;

const PageTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.75rem;

  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const PageLead = styled.p`
  margin: 0 auto 1.5rem;
  max-width: 34rem;
  color: #1b4332;
  font-size: 1rem;
  line-height: 1.45;

  @media (max-width: 768px) {
    font-size: 0.92rem;
  }
`;

const Destinations = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
  max-width: 720px;
  margin: 0 auto 2rem;

  @media (min-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const DestinationCard = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem 1.05rem;
  border-radius: 0.85rem;
  border: 2px solid ${(p) => (p.$emphasize ? '#f9a8d4' : '#fff')};
  background: ${(p) => (p.$emphasize ? '#fff7fb' : '#fff')};
  color: #1b4332;
  text-decoration: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  text-align: start;
  transition: transform 0.15s ease, border-color 0.15s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: ${(p) => (p.$emphasize ? '#f472b6' : '#1b4332')};
    color: #1b4332;
  }
`;

const DestinationTitle = styled.span`
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.3;
`;

const DestinationDesc = styled.span`
  font-size: 0.86rem;
  color: #4b5563;
  line-height: 1.4;
`;

const SuggestionsWrapper = styled.div`
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
`;

const SuggestionsNote = styled.p`
  margin: 0 0 1rem;
  color: #374151;
  font-size: 0.95rem;
  line-height: 1.4;
`;

const WhatToOfferPage = () => {
  const handleSuggestionSelect = (itemName) => {
    sessionStorage.setItem('suggestedItem', itemName);
    window.location.href = '/create-item';
  };

  return (
    <PageContainer>
      <Header>
        <PageTitle>💡 What Can You Offer?</PageTitle>
        <PageLead>
          Pick the right place first — bridal gowns and soiree dresses go in Pre-Owned Wedding &
          Occasion Wear, not Pre-Owned Curated Finds. Designers, boutiques, and artists should list
          through their own shop flows.
        </PageLead>
      </Header>

      <Destinations>
        {LISTING_TYPE_OPTIONS.map((option) => (
          <DestinationCard
            key={option.id}
            to={option.path}
            $emphasize={option.id === 'wedding'}
          >
            <DestinationTitle>{option.title}</DestinationTitle>
            <DestinationDesc>{option.description}</DestinationDesc>
          </DestinationCard>
        ))}
        {SELLER_LISTING_DESTINATIONS.map((dest) => (
          <DestinationCard key={dest.id} to={dest.path}>
            <DestinationTitle>{dest.title}</DestinationTitle>
            <DestinationDesc>{dest.description}</DestinationDesc>
          </DestinationCard>
        ))}
      </Destinations>

      <SuggestionsWrapper>
        <SuggestionsNote>
          Looking for everyday pre-owned ideas? Tap a suggestion below (opens the Pre-owned listing form).
        </SuggestionsNote>
        <ItemSuggestions
          onItemSelect={handleSuggestionSelect}
          defaultExpanded={true}
        />
      </SuggestionsWrapper>
    </PageContainer>
  );
};

export default WhatToOfferPage;
